module.exports = __webpack_public_path__ + "img/Profil_TailWing_I_CS-Ultraline-ii_Volume.d9b84edd.jpg";